import * as React from "react";

import Link from "./Link";

const HomeLink = () => <Link to="/">&#x27E8; Back Home</Link>;

export default HomeLink;
